<template>
  <div class="atras" @click="atras">
    <img src="@/assets/img/1x/Arrow-Left.png" alt="Flecha a la izquierda" />
    <p class="anterior">Anterior</p>
  </div>
</template>

<script>
export default {
  name: "ArrowLeft",
  methods: {
    atras() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
div.atras {
  max-width: 150px;
  cursor: pointer;
}

div.atras * {
  display: inline-block;
  vertical-align: middle;
}

.anterior {
  width: 60px;
  height: 22px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #237aba;
  margin-left: 11px;
  margin-top: 20px;
}

@media screen and (min-width: 600px) {
  div.atras:nth-child(1) {
    order: 2;
  }
}
</style>
